import { render, staticRenderFns } from "./PostDetail.vue?vue&type=template&id=f1395dd0&scoped=true"
import script from "./PostDetail.vue?vue&type=script&lang=js"
export * from "./PostDetail.vue?vue&type=script&lang=js"
import style0 from "./PostDetail.vue?vue&type=style&index=0&id=f1395dd0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1395dd0",
  null
  
)

export default component.exports